import $           from 'jquery';
import template    from './template.hbs';
import FormStep    from '../../classes/form-step';
import StripeElems from '../../util/stripeUtil';

export default new FormStep({

  $el: $('<form class="form-step step-preorder-payment" />'),

  template,

  events: {
    afterRender: 'initializePaymentForm'
  },

  rules: {
    first_name: /\S+/,
    last_name: /\S+/
  },

  // options for `stripe.elements()`
  getStripeOptions() {
    return {
      fonts: [
        {
          family: 'brown',
          // eslint-disable-next-line max-len
          src: 'url(\'https://dyajmw2sca9cs.cloudfront.net/fonts/lineto-brown-pro-light.eot?\') format(\'embedded-opentype\'), url(\'https://dyajmw2sca9cs.cloudfront.net/fonts/BrownProTT-Light.ttf\') format(\'truetype\')'
        }
      ]
    };
  },

  // options for apple + google pay
  getPaymentRequestOptions() {
    return {
      paymentRequestButton: '#payment-request-button',
      paymentRequest: {
        country: 'US',
        currency: 'usd',
        total: {
          label: 'Starry Internet',
          amount: 0
        },
        requestPayerName: true
      },
      paymentRequestStyle: {
        paymentRequestButton: {
          type: 'default',
          theme: 'light-outline'
        }
      }
    };
  },

  // default options for each individual stripe element
  getElementOptions() {
    return {
      classes: {
        base: 'cc-form'
      },
      style: {
        base: {
          fontWeight: 200,
          color: '#46425e',
          fontFamily: 'brown',
          fontSize: '14.5px',
          '::placeholder': {
            color: '#bfbfbf'
          }
        },
        invalid: {
          color: 'inherit'
        }
      }
    };
  },

  // care field options
  getCCFieldOptions() {
    return {
      cardNumber: {
        component: '#cc_number_element'
      },
      cardExpiry: {
        component: '#cc_expiry_element'
      },
      cardCvc: {
        component: '#cc_cvc_element'
      }
    };
  },

  // set up the payment form
  initializePaymentForm() {
    const stripe_opts          = this.getStripeOptions();
    const payment_request_opts = this.getPaymentRequestOptions();
    const cc_field_options     = this.getCCFieldOptions();
    const element_options      = this.getElementOptions();

    this.stripe = new StripeElems( stripe_opts, payment_request_opts );

    this.stripe.createElements( cc_field_options, {
      defaultElementOpts: element_options,
      events: {
        'change': this.handleCreditCardChange.bind( this ),
        'blur': this.handleCreditCardBlur.bind( this )
      }
    });

    this.initializePaymentRequests();
    this.stripe.renderFields();
  },

  // initialize apple + google pay
  initializePaymentRequests() {
    this.paymentRequestResponse = null;

    this.stripe.onPaymentRequestResponse = ev => {
      this.paymentRequestResponse = ev;

      if ( ev.token ) {
        this.$el.find('.hide-on-payment-api-success').hide();
        this.$el.find('.show-on-payment-api-success').show();
      }

      this.dispatch({ type: 'change', data: {} });
    };

    this.stripe.onCanMakePayment = () => {
      this.$el.find('#payment-request-text').show();
    };
  },

  // respond to `blur` events on stripe fields
  handleCreditCardBlur( context ) {
    this.updateErrorClass( context.element );
    this.updateErrorText( context.element );
    this.removeError( context.element );
  },

  // respond to `change/input` events on stripe fields
  handleCreditCardChange( context ) {
    this.removeError( context.element );
    // trigger 'change' event to force submit button to respect
    // new `isValid` result
    this.dispatch({ type: 'change', data: {} });
  },

  // update `error` class to correspond to element validity
  updateErrorClass( el ) {
    $( el.component )[ el.valid ? 'removeClass' : 'addClass' ]('error');
  },

  // update error message to correspond to element validity
  updateErrorText( el ) {
    $( el.component ).next('.error-message').text( el.getErrorMessage() );
  },

  // display a server-side Stripe error message
  showCardError( message ) {
    this.$el.find('.js-paymentError').text( message ).show();

    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    if ( this.paymentRequestResponse ) {
      this.paymentRequestResponse = null;
      this.stripe.gotPaymentRequestToken = false;
      this.$el.find('.hide-on-payment-api-success').show();
      this.$el.find('.show-on-payment-api-success').hide();
    }
  },

  // remove errors only...
  // typing should always clear out errors, never add them – until blur
  removeError( el ) {
    if ( el.valid ) {
      $( el.component ).removeClass('error');
      this.updateErrorText( el );
      this.$el.find('.js-paymentError').hide();
    }
  },

  // override isValid to include Stripe element status
  isValid( ...arg ) {
    return this.stripe.valid() && FormStep.prototype.isValid.apply( this, arg );
  },

  // generate stripe CC token before submitting
  beforeNext( state, done ) {
    let promise;

    if ( this.paymentRequestResponse ) {
      promise = Promise.resolve( this.paymentRequestResponse );
    } else {
      promise = this.stripe.createToken({});
    }

    promise.then( ({ token, error }) => {
      if ( error ) {
        const defaultMsg = 'Something went wrong, please try again';
        return this.showCardError( error.message || defaultMsg );
      }

      this.dispatch({ type: 'change', data: { token: token.id } });
      done();
    });
  },

  // include address in render context
  render( state ) {
    return FormStep.prototype.render.call( this, {
      gis_address: window.gis_address,
      ...state
    });
  }

});
